export { default } from './svg/lock.svg';
